export default __webpack_public_path__ + "static/star_bg-65c15cfb367ffd1916115c702f81cad1.svg";